// extracted by mini-css-extract-plugin
export default {"container":"H0kM8","fullDivider":"W+MKl","divider":"EfSrL"};